import { getMessages } from '../../../../../../../store/constants';

export const ASSIGNEE_REMOVE_BUTTON_TOOLTIP = getMessages().getText('card_form_assignee_remove');
export const ASSIGNEE_IN_WORK = getMessages().getText('card_form_assignee_in_work');
